var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-dashboard",
      class: ["card-dashboard-" + _vm.cardType, { clickable: _vm.clickable }]
    },
    [
      _c(
        "div",
        { staticClass: "card-dashboard-title" },
        [_c("span", [_vm._v(_vm._s(_vm.title))]), _vm._t("title")],
        2
      ),
      _c("div", { staticClass: "card-dashboard-content" }, [
        _c("div", { staticClass: "content-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.content))])
        ]),
        _c("div", { staticClass: "card-dashboard-icon" })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1652583c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1652583c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppCardDashboard.vue
// module id = null
// module chunks = 